<template>
	<div class="button-configuration pb-1 flex-space-between--center flex-column">
		<SettingTextInput ref="mainInput" title="Label" placeholder="Type the label here" :textFieldValue.sync="buttonLabel" />
		<SettingSelectInput title="Action" placeholder="Select action" :items="actionItems" :selection.sync="actionSelection" />

		<div class="action-options-section mt-2 width-100">
			<div v-if="actionSelection === ACTION_TYPES.OPEN_URL" class="">
				<SettingTextDataInput title="Url" placeholder="Enter url to open" :textFieldValue.sync="openUrl" />
				<SettingSelectInput title="Link behaviour" placeholder="Select action" :items="openUrlOptions" :selection.sync="openUrlSelection" />
			</div>
			<div v-else-if="actionSelection === ACTION_TYPES.DOWNLOAD_FILE" class="">
				<SettingTextDataInput title="File Url" placeholder="Enter url to download" :textFieldValue.sync="downloadFileUrl" />
			</div>
			<div v-else-if="actionSelection === ACTION_TYPES.COPY_TO_CLIPBOARD" class="">
				<SettingTextDataInput title="Text" placeholder="Enter text to copy" :textFieldValue.sync="copyToClipboardText" />
			</div>
		</div>
		<SettingSelectInput
			class="mt-2"
			title="Button style"
			placeholder="Select action"
			:items="buttonStyleItems"
			:selection.sync="buttonStyleSelection"
		/>
	</div>
</template>

<script>
import SettingTextInput from '../WidgetSettings/SettingTextInput';
import SettingSelectInput from '../WidgetSettings/SettingSelectInput';
import SettingTextDataInput from '../WidgetSettings/SettingTextDataInput';

import { ACTION_TYPES, OPEN_URL_OPTIONS, BUTTONS_STYLES } from './end-run-field.const';
import { ITEM_ONLY_ALLOWED_VALUE_TYPES } from '@/components/DataInput/DataInputMenu/helpers/data-input-menu.const';

const getSyncedComputed = (prop) => ({
	get() {
		return this.buttonConf[prop];
	},
	set(value) {
		const newButtonConf = { ...this.buttonConf, [prop]: value };
		this.$emit('updateButtonConf', newButtonConf);
	},
});

const selectOption = (text, value) => ({ text, value });

export default {
	name: 'ButtonConfiguration',
	components: { SettingTextInput, SettingSelectInput, SettingTextDataInput },
	props: {
		buttonConf: { type: Object },
		noSuffix: { type: Boolean },
		readonly: { type: Boolean },
		isOptionValue: { type: Boolean },
		keyPlaceholder: { type: String },
		valuePlaceholder: { type: String },
		addOptionText: { type: String },
		defaultOptionTemplate: { type: Object, default: () => ({ text: '', value: '' }) },
	},
	data() {
		return {
			ACTION_TYPES,
			ITEM_ONLY_ALLOWED_VALUE_TYPES,
			actionItems: [
				selectOption('Open Url', ACTION_TYPES.OPEN_URL),
				selectOption('Download file', ACTION_TYPES.DOWNLOAD_FILE),
				selectOption('Run feature again', ACTION_TYPES.RUN_FEATURE_AGAIN),
				// selectOption('Run a different feature', ACTION_TYPES.run_a_different_feature),
				// selectOption('Close tab or modal', ACTION_TYPES.close_tab_or_modal),
				// selectOption('Close modal', ACTION_TYPES.CLOSE_MODAL),
				selectOption('Copy to clipboard', ACTION_TYPES.COPY_TO_CLIPBOARD),
			],
			openUrlOptions: [
				selectOption('Open in new tab', OPEN_URL_OPTIONS.OPEN_IN_NEW_TAB),
				selectOption('Open in same tab', OPEN_URL_OPTIONS.OPEN_IN_SAME_TAB),
			],
			buttonStyleItems: [selectOption('Primary', BUTTONS_STYLES.PRIMARY), selectOption('Secondary', BUTTONS_STYLES.SECONDARY)],
		};
	},
	computed: {
		buttonLabel: getSyncedComputed('label'),
		actionSelection: getSyncedComputed('action'),
		openUrl: getSyncedComputed('openUrl'),
		openUrlSelection: getSyncedComputed('openUrlSelection'),
		downloadFileUrl: getSyncedComputed('downloadFileUrl'),
		copyToClipboardText: getSyncedComputed('copyToClipboardText'),
		buttonStyleSelection: getSyncedComputed('buttonStyleSelection'),
	},
	methods: {
		focusInput() {
			this.$refs.mainInput?.focusInput();
		},
	},
};
</script>

<style scoped lang="scss">
.button-configuration {
	.action-options-section {
		padding: 0 0 0 15px;
	}
}
</style>
